// extracted by mini-css-extract-plugin
export default {"mCard":"CC-z","image":"DC-z","imageNoBackground":"EC-z","imageHasCategory":"FC-z","fullWidth":"GC-z"};